import React from 'react';
import TextField from '@material-ui/core/TextField';
import { FormControl } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '../../../../assets/images/search-yellow.svg';

const TableHeader = ({ handleSearch }) => {
  const history = useHistory();

  const redirectToCreateIssuanceType = () => {
    history.push('/issuance-type/create');
  };

  const redirectToUserList = () => {
    history.push('/user/list');
  };

  return (
    <>
      <div className="table-filter-body">
        <div className="form-container">
          <div className="flex field-button-container">
            <FormControl variant="standard" className="form-control w-50">
              <TextField
                id="standard-basic"
                label="Search for information"
                name="search"
                onChange={(e) => handleSearch(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <img src={SearchIcon}></img>
                    </InputAdornment>
                  )
                }}
              />
            </FormControl>
            <div className="flex flex-wrap justify-between w-50">
              <Button
                variant="outlined"
                onClick={redirectToCreateIssuanceType}
              >
                Create Issuance Type
              </Button>
              <Button
                variant="outlined"
                onClick={redirectToUserList}
              >
                Back
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

TableHeader.propTypes = {
  handleSearch: PropTypes.func
};

export default TableHeader;
